export default __webpack_public_path__ + "static/media/jadecitadel.8a61bb7a.jpg";